import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { DeletionEntry } from '../services/deletion-registry.service';
import { switchMap } from 'rxjs/operators';
import { Observable, of, timer } from 'rxjs';
import { ApiResponse } from '../models/api/api-response';

@Injectable({ providedIn: 'root' })
export class DeletionGuardHandler {

  attempt(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
    entry: DeletionEntry,
    attemptsLeft: number = entry.maxAttempts,
    idsSnapshot: ReadonlySet<string> = new Set(entry.ids.keys()),
  ): Observable<HttpEvent<unknown>> {
    const delayMs: number = entry.delayMs;
    const idField: string = entry.idField;

    return next(req).pipe(
      switchMap(event => {
        if (!(event instanceof HttpResponse)) {
          return of(event);
        }

        if (attemptsLeft <= 1) {
          return of(event);
        }

        const body = event.body as ApiResponse<Record<string, unknown>> | null;
        const items: unknown[] = body?.items ?? [];

        const ghostIds: string[] = items
          .map((item: unknown) => (item as Record<string, unknown>)?.[idField])
          .filter((id): id is string => typeof id === 'string' && idsSnapshot.has(id));

        if (ghostIds.length === 0) {
          return of(event);
        }

        console.log(
          `[DeletionGuard] ${ghostIds.length} ghost ID(s) on "${req.url}", retrying in ${delayMs}ms (${attemptsLeft - 1} left)`
        );

        return timer(delayMs).pipe(
          switchMap(() => this.attempt(req, next, entry, attemptsLeft - 1, idsSnapshot))
        );
      }),
    );
  }
}
